import {LastIdService} from "./last-id.service";

export const LastIdInjectables: Array<any> = [
  {
    provide: LastIdService,
    useClass: LastIdService,
  },
];
